import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { MuiThemeProvider } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import CircularProgress from "@material-ui/core/CircularProgress";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

import { WELCOME_PAGE } from "../../utils/Colors";
import {
  GET_PROCESSED_OBJECT,
  SORT_REST_BY_ACTIVE,
  CHECK_RESTAURANT_AVAILABILITY,
  LOWER_CASE_LIST
} from "../../utils/CommonFunctions";
import PostJSON from "../../utils/PostJSON";
import { BASE_URL, GET_LIST_LOCATION } from "../../utils/Urls";
import foodbookTheme from "../../hoc/Theme";

import { restaurantsList } from "../../store/actionCreators/restaurantsList";
import { RESTAURANT_PAGE_URL } from "../../utils/Route";

const COMMON_CONTAINER_STYLES = {
  padding: "10px 0px 16px 20px",
  "&:hover": {
    cursor: "pointer"
  }
};

const styles = theme => ({
  dialogRoot: {
    maxWidth: "300px",
    width: "100%",
    maxHeight: "400px"
  },
  header: {
    width: "100%",
    padding: "10px",
    backgroundColor: WELCOME_PAGE.primaryColor,
    color: "white"
  },
  restListContainer: {
    width: "100%"
  },
  restaurantCardActive: {
    ...COMMON_CONTAINER_STYLES
  },
  restaurantCardInactive: {
    ...COMMON_CONTAINER_STYLES,
    opacity: 0.5
  },
  circularProgress: {
    width: "100%",
    textAlign: "center",
    padding: "10px"
  }
});

class SwitchRestaurant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      restaurants: props.restList || {}
    };
  }

  fetchRestaurants = () => {
    // console.log("api called!");
    const currentFoodcourtDetails =
      JSON.parse(localStorage.getItem("currentFoodCourt")) || {};
    const params = {
      foodcourt: currentFoodcourtDetails.value,
      userlat: 12.23,
      userlon: 123.45,
      useros: "android",
      pushid: ""
    };

    PostJSON(
      BASE_URL + GET_LIST_LOCATION,
      params,
      res => {
        const extras = res.extras || {};
        const restList = extras.restlist || {};
        this.setState({ restaurants: restList });
        this.props.storeRestaurantsList(restList);
      },
      error => {
        console.log("error", error);
      }
    );
  };

  componentDidMount() {
    const { restaurants } = this.state;
    const restKeys = Object.keys(restaurants);
    if (restKeys.length === 0) this.fetchRestaurants();
  }

  navigateToRestaurant = restid => event => {
    this.props.history.replace(RESTAURANT_PAGE_URL + "/" + restid);
    this.props.handleClose();
  };

  render() {
    const { classes, open } = this.props;
    const { restaurants } = this.state;
    const restAlive = restaurants["ralive"] || [];
    let headers = null;
    let values = null;
    let processedRestList = null;
    if (Object.keys(restaurants).length > 0) {
      headers = restaurants.rlist.headers;
      values = restaurants.rlist.values;
      processedRestList = GET_PROCESSED_OBJECT(headers, values).filter(res => {
        if (this.props.preorder) {
          return res.extras.preorder;
        }
        return true;
      });
    }

    let sortActiveRestaurants = [];
    if (processedRestList) {
      sortActiveRestaurants = SORT_REST_BY_ACTIVE(processedRestList, restAlive);
    }

    let restList = null;
    if (sortActiveRestaurants.length > 0) {
      <List>
        {
          (restList = sortActiveRestaurants
            .filter(rest => {
              if (!this.props.preorder && rest.hasdinein) {
                return true;
              } else if (this.props.preorder && rest.extras.preorder) {
                if (LOWER_CASE_LIST(rest.extras.sessionlist || [])
                    .includes((this.props.preOrderData.session || "").toLowerCase())) {
                  return true;
                }
              }
              return false;
            })
            .map(restaurant => (
              <ListItem
                className={
                  this.props.preorder && restaurant.extras.preorder
                    ? classes.restaurantCardActive
                    : CHECK_RESTAURANT_AVAILABILITY(
                        restaurant["servingtime"],
                        restaurant["extras"]["isbuffet"],
                        restaurant["uniqid"],
                        restAlive
                      )
                    ? classes.restaurantCardActive
                    : classes.restaurantCardInactive
                }
                button
                onClick={this.navigateToRestaurant(restaurant["uniqid"])}
              >
                <ListItemText primary={restaurant["name"]} />
              </ListItem>
            )))
        }
      </List>;
    }

    return (
      <Dialog
        open={open}
        onClose={this.props.handleClose}
        classes={{
          paper: classes.dialogRoot
        }}
      >
        <div className={classes.header}>Select Food Program</div>
        <div className={classes.restListContainer}>
          {restList ? (
            restList
          ) : (
            <div className={classes.circularProgress}>
              <MuiThemeProvider theme={foodbookTheme}>
                <CircularProgress />
              </MuiThemeProvider>
            </div>
          )}
        </div>
      </Dialog>
    );
  }
}

const mapStateToProps = state => {
  return {
    preOrderData: state.preorderData || {}
  }
}

const mapDispatchToProps = dispatch => {
  return {
    storeRestaurantsList: restaurants => dispatch(restaurantsList(restaurants))
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SwitchRestaurant))
);



// WEBPACK FOOTER //
// ./src/components/Dashboard/switchRestaurant.js